export default __webpack_public_path__ + "static/media/search_icon.86e62862.svg";